import { ApiResponse, CustomQueryResponse } from "../../../../model/common/apiResponse";
import { axiosService, ServiceEndPoint } from "../../../../Services/common/Axios.service";

const SERVICE_URL = ServiceEndPoint.outbound_service;
const ACCOUNT_SERVICE_URL = ServiceEndPoint.account_service;

export async function fetchPickPlan(page?: number, payload?: any): Promise<ApiResponse<CustomQueryResponse<any>>> {
  const response = await axiosService.post(`${SERVICE_URL}pick-plans/query`, payload);
  return response.data;
}

export async function deletePickPlanById(id:string): Promise<ApiResponse<any>> {
  const response = await axiosService.delete(`${SERVICE_URL}pick-plans/${id}`);
  return response.data;
}

export async function getPickPlanDetails(id: string): Promise<ApiResponse<any>> {
  const response = await axiosService.get(`${SERVICE_URL}pick-plans/${id}`);
  return response.data;
}

export async function fetchPickTypeLookup(): Promise<ApiResponse<any>> {
    const response = await axiosService.get(`${ACCOUNT_SERVICE_URL}lookup/pick_tickets.pick_method`);
  return response.data;
}

export async function fetchPickPlanConditionColumn(): Promise<ApiResponse<any>> {
  const response = await axiosService.get(`${ACCOUNT_SERVICE_URL}lookup/allocation_configs.condition_columns`);
  return response.data;
}

export async function fetchPickPlanOrderByColumn(): Promise<ApiResponse<any>> {
  const response = await axiosService.get(`${ACCOUNT_SERVICE_URL}lookup/allocation_configs.order_bys`);
  return response.data;
}

export async function submitPickPlanForm(data: any): Promise<ApiResponse<any>> {
  const response = await axiosService.post(`${SERVICE_URL}pick-plans`, data);
  return response.data;
}

export async function updatePickPlanForm(id: string, data: any): Promise<ApiResponse<any>> {
  const response = await axiosService.put(`${SERVICE_URL}pick-plans/${id}`, data);
  return response.data;
}
